<template>
    <div id="app">
        <div class="topHeader">
            <div class="container topNav">
                <nav class="nav mr-auto">
                    <a class="" href="javascript:" @click="$modal.show('schedule')">График работы и контакты</a>
                    <a class="" href="javascript:" @click="$modal.show('roadMap')">Карта проезда</a>
                    <a class="" href="javascript:" @click="$modal.show('feedback')">Напишите нам</a>
                </nav>
                <!--<nav class="nav">-->
                    <!--<a class="notifications" href="javascript:"><i class="las la-bell"></i><span>0</span> Оповещения</a>-->
                <!--</nav>-->
            </div>
        </div>
        <div class="headerBackground">
            <div class="container">
                <header class="py-3">
                    <div class="row justify-content-between align-items-center">
                        <div class="col-lg-3 pt-1">
                            <a class="logo" href="/"><img src="./../assets/img/logo3.png" /></a>
                        </div>
                        <div class="col-lg-2 text-center">
<!--                            <img style="width: auto;" src="./../assets/img/30years.png" />-->
<!--                            <img src="./../assets/img/header.jpg" class="actionHeader" />-->
<!--                            <a href="/news/100753"><img src="./../assets/img/header.jpg" class="actionHeader" /></a>-->
<!--                            <img src="./../assets/img/header2.png" class="actionHeader ac2" />-->
                            <!--<img src="./../assets/img/header3.png" class="actionHeader" style="height: 88px; width: auto; position: absolute; top: -30px; left: 455px;" />-->
                            <!--<img src="./../assets/img/header.png" style="height: 88px; width: auto; position: absolute; top: -30px; left: 350px;" />-->

                            <router-link  v-if="banner1.id != 0" :to="'/news/' + banner1['newsID']"><img :src="'https://sale.katris.ru/uploads/images/saleKatrisBanners/' + banner1['imageLink']" class="actionHeader" /></router-link>
                        </div>
                        <div class="col-lg-2 text-center">
<!--                            <img src="./../assets/img/header2.png" class="actionHeader" />-->
                        </div>
<!--                        <div class="col-lg-2">-->
<!--                            <router-link v-if="session.kredit !== false && session.dolg && session.loginId != '2768'" to="/additionalFeatures/paymentsSchedule" class="credit">-->
<!--                            &lt;!&ndash;<router-link  to="/additionalFeatures/paymentsSchedule" class="credit">&ndash;&gt;-->
<!--                                <div class="row">-->
<!--                                    <div class="col-md-3 warning">-->
<!--                                        <i class="las la-exclamation-triangle"></i>-->
<!--                                    </div>-->
<!--                                    <div v-if="session.dolg <= 0" class="col-md-9 text">-->
<!--                                        У Вас есть заказы, платеж по которым просрочен!-->
<!--                                        <strong>График платежей</strong>-->
<!--                                    </div>-->
<!--                                    <div v-else-if="session.dolg <= 4" class="col-md-9 text">-->
<!--                                        У Вас есть заказы с истекающим через-->
<!--                                        <span v-if="session.dolg == 1">1 день</span>-->
<!--                                        <span v-else>{{session.dolg}} дня</span> сроком оплаты.-->
<!--                                        <strong>График платежей</strong>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </router-link>-->

<!--&lt;!&ndash;                        <div class="col-md-4 d-flex justify-content-end align-items-center">&ndash;&gt;-->
<!--&lt;!&ndash;                            <input type="text" class="search" />&ndash;&gt;-->
<!--&lt;!&ndash;                            <a class="searchLink" href="javascript:" aria-label="Search">&ndash;&gt;-->
<!--&lt;!&ndash;                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="mx-3" role="img" viewBox="0 0 24 24" focusable="false"><title>Search</title><circle cx="10.5" cy="10.5" r="7.5"/><path d="M21 21l-5.2-5.2"/></svg>&ndash;&gt;-->
<!--&lt;!&ndash;                            </a>&ndash;&gt;-->
<!--                        </div>-->
                        <div class="col-lg-3 text-right">
                            <a v-if="banner2.id != 0" :href="'/news/' + banner2['newsID']"><img :src="'https://sale.katris.ru/uploads/images/saleKatrisBanners/' + banner2['imageLink']" class="actionHeader" /></a>
                            <router-link v-else to="/translation"><img src="./../assets/img/translation.png" class="translation" style="" /></router-link>
<!--                            <a href="/news/100744"><img src="./../assets/img/header_rm_new2.jpg" class="" style="margin-left: 34px;" /></a>-->
                        </div>
                        <div class="col-lg-2 text-right">
<!--                            <a href="#" class="basketLink" style="margin-right: -20px;" @click="$modal.show('video-storage')">-->
<!--                            <a href="/translation" class="basketLink">-->
<!--                                <button class="btn btn-primary storage">-->
<!--                                    <img src="./../assets/img/warehouse-100.png" />-->
<!--                                    <span style="display: block; width: 82px; font-size: 10px; line-height: 1; position: absolute; right: 0px; top: 50px;">Онлайн трансляция работы склада</span>-->
<!--                                </button>-->
<!--                            </a>-->
                            <a href="#" class="basketLink">
                                <!--<button class="btn btn-primary basket" v-bind:class="{active: basketActive}">-->
                                    <!--<img src="./../assets/img/bell.png" />-->
                                    <!--<span v-if="count.manual > 0">{{ count.basket + count.manual}}</span>-->
                                    <!--<span v-else>{{ count.basket}}</span>-->
                                <!--</button>-->

                                <v-popover placement="bottom" popoverClass="notificationsPopover">
                                    <button class="btn btn-primary basket tooltip-target" v-bind:class="{active: waitActive}">
                                        <img v-if="notificationsParams.emptyNotices" src="./../assets/img/bellEmpty.png" />
                                        <img v-else src="./../assets/img/bell.png" />
                                        <span>{{ notifications.length }}</span>
                                    </button>

                                    <template slot="popover">
                                        <button v-if="notifications.length == 0" @click="$modal.show('about-notify')" class="btn btn-outline-primary notifyHowTo"><i class="las la-info"></i></button>

                                        <p v-if="notifications.length == 0">
                                            Нет новых уведомлений
                                            <span v-if="!notificationsParams.emptyNotices"><br/><br/>Добавлено позиций<br/> в список ожидания: {{ notificationsParams.waitListLength }}</span>
                                        </p>

                                        <perfect-scrollbar>
                                        <!--<div style="max-height: 500px; overflow-y: scroll" v-else>-->
                                            <table  class="table">
                                                <tr v-for="notification in notifications" v-bind:key="notification.id">
                                                    <td>
                                                        <img :src="'https://sale.katris.ru/uploads/___res_w80_q60/images/saleKatrisCatalog/' + notification.img + '.png'" :alt="notification.gdsName" class="ml-2" />
                                                    </td>
                                                    <td>
                                                        Поступило в наличие: {{notification.gdsName}} <br/>
                                                        <router-link v-if="notification.type == 1" to="/accessoriesOrdering">Перейти</router-link>
                                                        <router-link v-else-if="notification.type == 2" to="/orderFromCatalog">Перейти</router-link>
                                                        <router-link v-else-if="notification.type == 3" to="/readyMade">Перейти</router-link>
                                                    </td>
                                                    <td>
                                                        <a href="javascript:" @click="disableNotifications(notification)" style="font-size: 20px; margin-right: 10px;"><i class="las la-times"></i></a>
                                                    </td>
                                                </tr>
                                            </table>
                                        <!--</div>-->
                                        </perfect-scrollbar>

                                        <a href="/waitList" class="btn btn-outline-primary mb-2 mt-2">Список ожидания</a>
                                    </template>
                                </v-popover>
                            </a>
                            <router-link to="/basket" class="basketLink">
                                <button class="btn btn-primary basket" v-bind:class="{active: basketActive}">
                                    <img v-if="count.basket <= 0" src="./../assets/img/emptyCart.png" />
                                    <img v-else src="./../assets/img/loadedCart.png" />
                                    <span v-if="count.manual > 0 || count.manual2 > 0">{{ count.basket + count.manual + count.manual2 }}</span>
                                    <span v-else>{{ count.basket }}</span>
                                </button>
                            </router-link>
                        </div>
                    </div>
                </header>
            </div>
        </div>
        <div class="headerBackground" id="navbar">
            <div class="container">
                <div class="nav-scroller py-1 mb-2">
                    <nav class="nav d-flex justify-content-between">
                        <router-link v-if="actions" to="/actions">Акции</router-link>
                        <router-link v-bind:class="{notActive: actions}" to="/">Новости</router-link>
                        <router-link v-if="session.newType == 0 || session.accOrders == 1" v-bind:class="{active: ordersStateActive}" to="/ordersState">Состояние заказов</router-link>
                        <router-link v-if="session.newType == 0 || session.accKomplect == 1" v-bind:class="{active: orderingActive}" class="ordering" to="/accessoriesOrdering">
                            Заказ комплектующих
                            <!--<span>{{ count.number }}</span>-->
                        </router-link>
                        <router-link v-if="session.newType == 0 || session.accGP == 1" to="/readyMade" class="rm">Готовые изделия</router-link>
                        <router-link to="/additionalFeatures"><span v-if="actions">Доп. возможности</span><span v-else>Дополнительные возможности</span></router-link>
                        <a class="" href="javascript:" @click="logout">Выход</a>
                    </nav>
                </div>
            </div>
        </div>

        <router-view />

        <footer>
            <div class="footer-top">
                <div class="container">
                    <div class="row">
                        <div class="col-md-4">
                            <a class="logo" href="/"><img src="./../assets/img/logo2.png"/></a>
<!--                            <img style="margin-top: 40px;" src="./../assets/img/footer30.png"/>-->
<!--                            <a href="https://www.instagram.com/foroom_official_russia/" target="_blank" class="d-block mt-4" style="font-size: 12px">-->
<!--                                <i class="lab la-instagram" style="font-size: 34px"></i>-->
<!--                                <span style="vertical-align: 8px;">Новости ПСК FOROOM</span>-->
<!--                            </a>-->
                        </div>
                        <div class="col-md-4">
                            <ol class="list-unstyled">
                                <li v-if="actions"><router-link to="/actions">Акции</router-link></li>
                                <li><router-link to="/">Новости</router-link></li>
                                <li v-if="session.newType == 0 || session.accOrders == 1"><router-link to="/ordersState">Состояние заказов</router-link></li>
                                <li v-if="session.newType == 0 || session.accKomplect == 1"><router-link to="/accessoriesOrdering">Заказ комплектующих</router-link></li>
                                <li v-if="session.newType == 0 || session.accGP == 1"><router-link to="/readyMade">Готовые изделия</router-link></li>
                                <li><router-link to="/additionalFeatures">Дополнительные возможности</router-link></li>
                                <li><a href="javascript:" @click="logout">Выход</a></li>
                            </ol>
                        </div>
                        <div class="col-md-4">
                            <p>На комплектующие и готовые изделия установлены рублевые цены</p>
<!--                            <p>Курсы валют на {{info.kursDate}}</p>-->
<!--                            <p>Курсы валют на {{today[2]}}.{{today[1]}}.{{today[0]}}</p>-->
<!--                            <p>Готовые изделия: Цены в рублях!</p>-->
<!--&lt;!&ndash;                            <p>Комплектующие ЦБ: 1$ = {{info.kursUSD}} руб</p>&ndash;&gt;-->
<!--                            <p>Комплектующие: 1$ = {{info.kursUSD}} руб</p>-->
<!--&lt;!&ndash;                            <p>1€ = {{info.kursEURO}} руб</p>&ndash;&gt;-->
<!--                            <p>Последний вход: {{info.lastEnter}}</p>-->
                            <p>База обновлена: {{info.info}}</p>
                            <p><a href="/agreement">Текст дополнительного соглашения</a></p>
                            <p><a href="/files/politics.docx" target="_blank">Политика в отношении обработки персональных данных</a></p>
<!--                            <p><a href="/agreement">Положение об организации обработки персональных данных в ООО «Фирма «КАЛИТА»</a></p>-->
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer-bottom">
                <div class="container">
                    <p>Версия от 12.05.2026 © Все права защищены Катрис. © All rights reserved Katris</p>
                    <p class="font-weight-light" style="font-size: 14px">Поддерживаемые браузеры: Chromium (Chrome, Yandex, Opera, Edge), Firefox, Safari. Используйте только актуальные версии</p>
                </div>
            </div>
        </footer>

        <!--<div id="katrisChatBot" class="katrisChatBot" v-bind:class="{'onTop': bottomMenu, 'onBottom': !bottomMenu}">-->
            <!--<div id="preloader">-->
                <!--<div class="logo rotate"></div>-->
            <!--</div>-->
            <!--<div class="katrisChatBot_header" id="headerWrapper" @click="chatBotToggle()">-->
                <!--<div class="katrisChatBot_header-icon">-->
                    <!--<div class="katrisChatBot_header-icon-align-helper">-->
                        <!--<img id="agent-avatar" src="https://sale.katris.ru/img/ai_helper_init.png" />-->
                    <!--</div>-->
                <!--</div>-->
                <!--<div class="katrisChatBot_header-wrapper">-->
                    <!--<div class="katrisChatBot_header-agent-name">Катрис Чат Бот</div>-->
                    <!--<div class="katrisChatBot_header-description">Интеллектуальный помощник по сервисам</div>-->
                <!--</div>-->
            <!--</div>-->
            <!--<div class="katrisChatBot_powered_by">-->
                <!--<span>Разработано ООО "Фирма "КАЛИТА"</span>-->
            <!--</div>-->
            <!--<div class="katrisChatBot_result" id="resultWrapper">-->
                <!--<table class="katrisChatBot_result-table" id="resultTable">-->
                    <!--<tr>-->
                        <!--<td id="result">-->
                            <!--<div v-for="(message, index) in chatDialog" v-bind:class="{'server-response': message.type == 'r', 'user-request': message.type == 'q'}" v-bind:key="index">-->
                                <!--{{message.text}}-->
                            <!--</div>-->
                        <!--</td>-->
                    <!--</tr>-->
                <!--</table>-->
            <!--</div>-->
            <!--<div class="clearfix"></div>-->
            <!--<div class="block_input" id="queryWrapper">-->
                <!--<div id="katrisChatBotForm">-->
                    <!--<input type="text" name="q" id="query" placeholder="Введите вопрос..."/>-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->

        <modal name="schedule" :min-width="200"
               :min-height="200"
               :adaptive="true"
               :scrollable="true"
               :reset="true"
               width="40%"
               height="auto">
            <div style="padding: 20px">
                <h3>График работы и контакты</h3>

                Интернет-магазин: круглосуточно<br>
                Самовывоз: с 10.00 до 17.00 MSK<br><br/>
                <h5>График работы.</h5>
                пн-пт: 9.00-17.30<br>
                сб-вс: выходной
                <br>
                <br>
                Ваши персональные менеджеры в компании КАТРИС:<br><br>
                <table class="table table-borderless" v-for="(manager, index) in managers" v-bind:key="index">
                    <tbody>
                    <tr>
                        <td style="text-align:right; padding-right:10px; width: 300px;">
                            {{manager.post}}
                        </td>
                        <td>
                            <strong>{{manager.lastname}} {{manager.name}} {{manager.patronymic}}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td style="text-align:right; padding-right:10px;">Телефон</td>
                        <td>+7 (495) 790-7770 доб. {{manager.phExt}}</td>
                    </tr>
                    <tr>
                        <td style="text-align:right; padding-right:10px;">E-Mail</td>
                        <td><a href="mailto:tmk@katris.ru">{{manager.email}}</a></td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <br>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div class="row justify-content-center">
                    <div class="col-md-4">
                        <button class="btn btn-outline-primary btn-block" @click="$modal.hide('schedule')">Закрыть</button>
                    </div>
                </div>
            </div>
        </modal>

        <modal name="roadMap" :min-width="200"
               :min-height="200"
               :adaptive="true"
               :scrollable="true"
               :reset="true"
               width="60%"
               height="auto">
            <div style="padding: 20px; text-align: center">
                <h3>Карта проезда</h3>

                <img class="w-100 mb-3" src="../assets/img/newMap.jpg" alt="Карта проезда" />

                <div class="row justify-content-center">
                    <div class="col-md-4">
                        <button class="btn btn-outline-primary btn-block" @click="$modal.hide('roadMap')">Закрыть</button>
                    </div>
                </div>
            </div>
        </modal>

        <modal name="feedback" :min-width="200"
               :min-height="200"
               :adaptive="true"
               :scrollable="true"
               :reset="true"
               width="40%"
               height="auto">
            <div style="padding: 20px">
                <h3>Обратная связь</h3>

                <strong>Вы можете:</strong>
                <br>
                <div class="custom-control custom-radio">
                    <input id="writeToUsThank" name="reason" type="radio" value="1" class="custom-control-input" required="" v-model="form.reason">
                    <label class="custom-control-label" for="writeToUsThank">Сказать "СПАСИБО" нашим менеджерам</label>
                </div>
                <div class="custom-control custom-radio">
                    <input id="writeToUsMake" name="reason" type="radio" value="2" class="custom-control-input" required="" v-model="form.reason">
                    <label class="custom-control-label" for="writeToUsMake">Предложить нам что-то реализовать в Интернет-магазине</label>
                </div>
                <div class="custom-control custom-radio">
                    <input id="writeToUsErFind" name="reason" type="radio" value="6" class="custom-control-input" required="" v-model="form.reason">
                    <label class="custom-control-label" for="writeToUsErFind">Сообщить об ошибке на этом сайте</label>
                </div>
                <div class="custom-control custom-radio">
                    <input id="writeToUsDelivery" name="reason" type="radio" value="3" class="custom-control-input" required="" v-model="form.reason">
                    <label class="custom-control-label" for="writeToUsDelivery">Выразить претензии к доставке</label>
                </div>
                <div class="custom-control custom-radio">
                    <input id="writeToUsAssort" name="reason" type="radio" value="4" class="custom-control-input" required="" v-model="form.reason">
                    <label class="custom-control-label" for="writeToUsAssort">Посетовать на ассортимент</label>
                </div>
                <div class="custom-control custom-radio">
                    <input id="writeToUsBad" name="reason" type="radio" value="5" class="custom-control-input" required="" v-model="form.reason">
                    <label class="custom-control-label" for="writeToUsBad">Пожаловаться генеральному директору</label>
                </div>
                <strong>И все это можно сделать не стесняясь:</strong>
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="writeToUsAnonim" v-model="form.anon">
                    <label class="custom-control-label" for="writeToUsAnonim">абсолютно анонимно</label>
                </div>
                <br>
                <textarea id="writeToUsText" class="form-control" v-model="form.text"></textarea>
                <div class="row justify-content-center mt-3">
                    <div class="col-md-4">
                        <button class="btn btn-outline-primary btn-block mb-3" @click="sendMessage()">Отправить</button>
                    </div>
                    <div class="col-md-4">
                        <button class="btn btn-outline-primary btn-block mb-3" @click="$modal.hide('feedback')">Уже не хочу</button>
                    </div>
                </div>
            </div>
        </modal>

        <modal name="about-notify" :min-width="200"
               :min-height="200"
               :adaptive="true"
               :scrollable="true"
               :reset="true"
               width="60%"
               height="auto">
            <div style="padding: 20px">
                <div>
                    <strong class="text-center">УВЕДОМЛЕНИЕ О ДОСТУПНОСТИ РАНЕЕ ОТСУТСТВУЮЩИХ ПОЗИЦИЙ К ЗАКАЗУ</strong>
                    <p>Доступно для разделов интеллектуального заказа и ручного заказа, а также при заказе изделий Ready Made.</p>
                    <p>Целью данной опции является своевременное информирование вас о доступности ожидаемых вами материалов к заказу.</p>
                    <p>Если: </p>
                    <ul>
                        <li> Список ожидания пуст - колокольчик перечеркнут.</li>
                        <li> Позиции добавлены в список ожидания - колокольчик активен.</li>
                        <li> Позиции из списка ожидания стали доступны к заказу, то рядом с колокольчиком будет отображаться цифра, указывающая на общее число доступных к заказу позиций.</li>
                    </ul>
                    <p>Подробнее:</p>
                    <ul>
                        <li>Для получения уведомления о поступлении какой-либо отсутствующей позиции на склад и ее доступности к заказу, нажмите соответствующую кнопку "уведомить о поступлении", напротив позиции, которая вам интересна.</li>
                        <li>Для просмотра всех позиций, для которых вы назначили уведомления, нажмите на колокольчик и выберите "список ожидания"</li>
                        <li>Когда интересующие вас материалы стали доступны к заказу, то при нажатии на значок колокольчика сразу выпадет список с перечнем этих позиций. При этом напротив каждой позиции будет находиться кнопка "перейти", при нажатии на неё вы перейдете в тот раздел заказа (ручной, интеллектуальный или Ready Made), из которого данный материал был добавлен в список ожидания.</li>
                    </ul>
                </div>
                <div class="row justify-content-center">
                    <div class="col-md-4">
                        <button class="btn btn-outline-primary btn-block" @click="$modal.hide('about-notify')">Закрыть</button>
                    </div>
                </div>
            </div>
        </modal>

        <modal name="video-storage" :min-width="200"
               :min-height="200"
               :scrollable="true"
               :reset="true"
               width="600px"
                height="auto">
            <div style="padding: 20px">
                <div id="video" class="text-center">
                    <h2>Видеотрансляция</h2>
<!--                    <iframe style="width: 100%; height: 480px" src="https://www.youtube.com/embed/s2MddnG4V5U" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->

                    <p>Наименование видео</p>
                    <iframe height="370px" width="100%" class="lessonsVideo" src="https://stream.foroom.ru/?id=4" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    <p>Описание видео</p>

                    <hr/>

                    <p>Наименование видео</p>
                    <iframe height="370px" width="100%" class="lessonsVideo" src="https://stream.foroom.ru/?id=5" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    <p>Описание видео</p>

                    <hr/>

                    <p>Наименование видео</p>
                    <iframe height="370px" width="100%" class="lessonsVideo" src="https://stream.foroom.ru/?id=6" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    <p>Описание видео</p>
                </div>
                <div class="row justify-content-center">
                    <div class="col-md-4">
                        <button class="btn btn-outline-primary btn-block" @click="$modal.hide('video-storage')">Закрыть</button>
                    </div>
                </div>
            </div>
        </modal>

        <div class="notice" v-bind:class="{active: added.state}">
            <p>Добавлено в корзину</p>
        </div>

        <cookie-law theme="dark-lime--rounded" class="not-print" buttonText="Принять" message="Продолжая использовать наш сайт, Вы соглашаетесь на обработку файлов cookie, которые необходимы для работы веб-сайта, типе, языке и версии операционной системы и браузера, сведениях об используемом устройстве."></cookie-law>
    </div>
</template>

<script>
    import makePost from '../js/makePost';
    // import rm_katris from "../js/rm_katris/app";
    import ai_helper from "../js/aihelper/ai_helper";
    import ServiceClass from "../js/rm_katris/main/ServiceClass";

    import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

    import CookieLaw from 'vue-cookie-law'

    let chat, input, resultWrapper, preloader;
    let opened = '0px', closed = '-456px';

    let basketStorage

    export default {
        name: 'Default',
        components: {
            PerfectScrollbar,
            CookieLaw
        },
        data() {
            return {
                info: {
                    info: '',
                    lastEnter: '',
                    kursUSD: '',
                    kursEURO: '',
                    kursDate: ''
                },
                form: {
                    reason: 0,
                    anon: 0,
                    text: ''
                },
                year: new Date().getFullYear(),
                managers: [],
                ordersStateActive: false,
                orderingActive: false,
                basketActive: false,
                session: this.$session.get('user'),
                count: {
                    number: 0,
                    basket: 0,
                    manual: 0
                },
                chatBotState: false,
                closeTimer: null,
                chatDialog: [],
                chatMessageInProgress: false,
                bottomMenu: false,
                chatJivoMode:false,
                chatJivoTimer: false,
                chatJivoTimeout: false,
                chatJivoDialogStart: 0,
                added: {
                    state: false
                },
                actions: false,
                waitActive: false,
                notifications: [],
                notificationsParams: {
                    emptyNotices: true, waitListLength: 0
                },
                today: new Date().toJSON().slice(0,10).split('-'),
                banners: [],
                banner1: {
                    id: 0
                },
                banner2: {
                    id: 0
                }
            }
        },
        created() {
            let self = this;

            // this.$logout()

            self.added = self.$added;

            let params = {
                url: 'https://sale.katris.ru/proxy/',
                session: this.$session.get('user')
            };

            // console.log(this.$aiHelper)
            //
            // if (this.$aiHelper === false) {
            //     this.$aiHelper = ai_helper;
            // }

            ai_helper.init(params, function() {
                // this.$loaded = true;
            });
            ai_helper.restoreComplects();

            this.$countGlobal.number = 0;
            this.$countGlobal.basket = 0;
            this.$countGlobal.manual2 = 0;

            basketStorage = new ServiceClass('rmItemsBasket')

            for (let key in ai_helper.complects) {
                if (ai_helper.complects[key] != 'empty') {
                    // console.log(ai_helper.complects[key].inBusket)
                    if (ai_helper.complects[key].id != 0) {
                        if (ai_helper.complects[key].inBusket)
                            this.$countGlobal.basket++;
                        else
                            this.$countGlobal.number++;
                    } else {
                        for (let good in ai_helper.complects[key].goods) {
                            if (ai_helper.complects[key].goods[good].partner) {
                                this.$countGlobal.manual2++
                            }
                        }

                        this.$countGlobal.manual = Object.keys(ai_helper.complects[key].goods).length - this.$countGlobal.manual2;
                    }
                }
            }

            console.log(this.$countGlobal)

            let rmBasketCount = basketStorage.get('basketCount')

            // console.log('mrmb', rmBasketCount)

            if (rmBasketCount > 0) {
                this.$countGlobal.basket += basketStorage.get('basketCount')
            }

            this.count = this.$countGlobal;

            ai_helper.makePost('katrisService', 'getActionsList', {'token': this.$session.get('jwt')}, null, function(response) {
                // console.log(response)
                if (response.status === 'OK') {
                    if (response.data && response.data.length > 0) {
                        self.actions = true;
                    }
                }
            });

            makePost('katrisService', 'getInfo', {'token': this.$session.get('jwt')}, null, function(response) {
                if (response.status === 'OK') {
                    response = JSON.parse(response.data);
                    if (!response.error) {
                        self.info = response;
                    } else {
                        self.$logout();
                    }
                } else {
                    self.$logout();
                }
            });

            ai_helper.makePost('katrisService', 'getBanners', {'token': this.$session.get('jwt')}, null, function(response) {
                if (response.status === 'OK') {
                    self.banners = response.data;

                    for (let banner in self.banners) {
                        if (self.banners[banner].position == 1) {
                            self.banner1 = self.banners[banner];
                        } else if (self.banners[banner].position == 2) {
                            self.banner2 = self.banners[banner];
                        }
                    }

                }
            });

            ai_helper.makePost('katrisOrdersState', 'managerInfo', {}, null, function(response) {
                if (response.status === 'OK') {
                    for (let key in response.data) {
                        self.managers.push(response.data[key]);
                    }
                }
            });

            if (this.$route.matched[0].path === '/order/:orderId' || this.$route.matched[0].path === '/reorder/:orderId') {
                this.ordersStateActive = true;
            } else {
                this.ordersStateActive = false;
            }

            if (this.$route.matched[0].path === '/configurator/:id' || this.$route.matched[0].path === '/configurator' || this.$route.matched[0].path === '/itemsList/:setId/:groupId' || this.$route.matched[0].path === '/orderFromCatalog') {
                this.orderingActive = true;
            } else {
                this.orderingActive = false;
            }

            if (this.$route.matched[0].path === '/configurator/:id' || this.$route.matched[0].path === '/configurator' || this.$route.matched[0].path === '/itemsList/:setId/:groupId') {
                opened = '55px';
                closed = '-401px';
                this.bottomMenu = true;
            } else {
                opened = '0px';
                closed = '-456px';
                this.bottomMenu = false;
            }

            if (this.$route.matched[0].path === '/waitList') {
                this.waitActive = true;
            } else {
                this.waitActive = false;
            }

            if (this.$route.matched[0].path === '/basket') {
                this.basketActive = true;
                this.waitActive = false;
            } else {
                this.basketActive = false;
            }

            self.$notificationsGlobal.emptyNotices = false;
            self.$notificationsGlobal.waitListLength = 0;

            ai_helper.makePost('katrisService', 'getNotifications', {'token': this.$session.get('jwt')}, null, function(response) {
                if (response.status === 'OK') {
                    if (response.data == null) self.$notificationsGlobal.emptyNotices = true;

                    if (response.data != null) self.$notificationsGlobal.waitListLength = response.data.length;

                    self.notificationsParams = self.$notificationsGlobal;

                    for (let obj in response.data) {
                        if (response.data[obj].active != 0) {
                            let id = response.data[obj].id;
                            let type = response.data[obj].type;
                            ai_helper.makePost('katrisService', 'getItem', {'goodID': response.data[obj].goodID, 'token': self.$session.get('jwt')}, null, function (response) {
                                // response.data.gdsInStock = 10;
                                if (response.data.gdsInStock >= response.data.minOrder) {
                                    response.data.notificationID = id;
                                    response.data.type = type;
                                    self.notifications.push(response.data)
                                }
                            });
                        }
                    }
                }
            });

            window.addEventListener('load', () => {
                chat = document.getElementById("katrisChatBot");
                input = document.getElementById('query');
                resultWrapper = document.getElementById('resultWrapper');
                // resultTable = document.getElementById('resultTable');
                preloader = document.getElementById('preloader');

                let data = {user: this.$session.get('user')};

                makePost('chatBotKatris', 'init_chat', data, null, function(resp) {
                    if (resp.status === 'OK') {
                        if (resp.data) {
                            if (resp.data.action && resp.data.action == 'init') {
                                // self.createDom();
                                if (resp.data.queryResponse) {
                                    self.chatBotInsertResponse('...');
                                    // resultWrapper.scrollTop = resultTable.offsetHeight;
                                    if (resultWrapper) resultWrapper.scrollTop = resultWrapper.scrollHeight;
                                    setTimeout(function() {
                                        self.chatDialog[0].text = resp.data.queryResponse;
                                        // self.dialog.response.innerHTML = resp.data.queryResponse;
                                        // self.controls.resultWrapper.scrollTop = self.controls.resultTable.offsetHeight;
                                    }, 500);
                                }
                            }
                            //if (resp.data.action) self.trigger(resp.data.action);
                        }
                    } else alert('Ошибка');
                });

                // self.closeTimer = setTimeout(function() {
                //     self.chatBotClose();
                // }, 2000);

                if (input) {
                    input.onclick = function () {
                        if (self.closeTimer) clearTimeout(self.closeTimer);
                        self.chatBotOpen();
                    };

                    input.onkeydown = function (ev) {
                        if (ev.keyCode == 13) {
                            self.chatBotSend();
                        }
                    };
                }

                setTimeout(function() {
                    if (preloader) preloader.style.opacity = 0;
                }, 100);
                setTimeout(function() {
                    if (preloader) preloader.style.display = 'none';
                }, 300);

            });
        },
        updated() {
            if (resultWrapper) resultWrapper.scrollTop = resultWrapper.scrollHeight;
        },
        methods: {
            logout: function() {
                this.$logout();
            },
            sendMessage: function() {
                if (this.form.reason != 1 && this.form.text == '') {
                    alert('Без слов можно сказать "СПАСИБО", а остальное просим пояснить');
                } else {
                    makePost('katrisService', 'feedback', {
                        'token': this.$session.get('jwt'),
                        'reason': this.form.reason,
                        'text': this.form.text,
                        'anonim': this.form.anon
                    }, null, function(response) {
                        // console.log(response)
                        if (response.status === 'OK') {
                            if (this.form.anon == 1) {
                                alert('Ваше обращение принято! Так как Вы отправили его анонимно, то мы даже не покажем присвоенный ему номер.');
                            } else {
                                alert('Ваше обращение принято! Мы присвоили ему номер ' + response.data);
                            }
                        } else {
                            alert('Глубоко сожалеем, но мы не смогли сохранить и передать Ваше обращение. Пожалуйста попробуйте еще раз через несколько минут.');
                        }
                    });
                }
            },
            chatBotToggle: function() {
                if (this.closeTimer) clearTimeout(this.closeTimer);

                if (this.chatBotState) {
                    this.chatBotClose();
                } else {
                    this.chatBotOpen();
                }
            },
            chatBotClose: function() {
                if (chat) chat.style.bottom = closed;
                this.chatBotState = false;
            },
            chatBotOpen: function() {
                if (chat) chat.style.bottom = opened;
                this.chatBotState = true;
            },
            chatBotSend: function() {
                let self = this;

                if (!self.chatMessageInProgress) {
                    // self.chatMessageInProgress = true;
                    let message = input.value;
                    input.value = '';
                    this.chatBotInsertRequest(message);
                    this.chatBotInsertResponse('...');
                    let data = {message: message, user: this.$session.get('user')};

                    if (self.chatJivoMode) data.jivo = true;

                    makePost('chatBotKatris', 'send_message_new', data, null, function(resp) {
                        // console.log(resp)
                        if (resp.status === 'OK') {
                            if (resp.data) {
                                if (resp.data.queryResponse) {
                                    self.chatDialog[self.chatDialog.length - 1].text = resp.data.queryResponse;
                                }
                                if (resp.data.jivo) {
                                    if (self.chatJivoMode) {
                                        clearInterval(self.chatJivoTimer);
                                        clearInterval(self.chatJivoTimeout);
                                        self.chatJivoTimer = false;
                                        self.chatJivoTimeout = false;
                                        self.jivoChat();
                                    } else {
                                        self.chatJivoMode = true;
                                        self.jivoChat();
                                    }
                                }
                                if (resp.data.action) self.chatTrigger(resp.data.action);
                                self.chatMessageInProgress = false;
                            }
                        } else {
                            self.chatDialog[self.chatDialog.length - 1].text = 'ERROR';
                            self.chatMessageInProgress = false;
                        }
                    });
                }
            },
            chatBotInsertRequest: function(text) {
                this.chatDialog.push({text: text, type: 'q'});
            },
            chatBotInsertResponse: function(text) {
                this.chatDialog.push({text: text, type: 'r'});
            },
            chatTrigger: function(action) {
                switch(action) {
                    case 'login': setTimeout(function() {window.location='https://sale.katris.ru'}, 2000); break;
                }
            },
            jivoChat: function() {
                let self = this;
                this.chatJivoTimer = setInterval(self.jivoCheck, 5000);
                this.chatJivoTimeout = setTimeout(self.jivoStop, 300000);
                // this.chatJivoTimeout = setTimeout(self.jivoStop, 50000);
                self.chatJivoDialogStart = new Date();
            },
            jivoCheck: function() {
                let self = this;
                makePost('chatBotKatris', 'checkMessages', {user: this.$session.get('user'), date: Math.round(self.chatJivoDialogStart.getTime() / 1000)}, null, function(resp) {
                    // console.log('jivo update');
                    if (resp.status === 'OK') {
                        if (resp.data) {
                            // console.log(JSON.parse(resp.data));
                            let messages = JSON.parse(resp.data);
                            for (let obj in messages) {
                                self.chatDialog.push({text: messages[obj].queryResponse, type: 'r'});
                            }
                        }
                    }
                });
            },
            jivoStop: function() {
                let self = this;
                clearInterval(self.chatJivoTimer);
                clearInterval(self.chatJivoTimeout);
                self.chatJivoTimer = false;
                self.chatJivoTimeout = false;
                self.chatJivoMode = false;
                // console.log('jivo stopped')
            },
            disableNotifications: function(item) {
                let self = this;
                ai_helper.makePost('katrisService', 'disableNotification', {'token': this.$session.get('jwt'), 'notificationID': item.notificationID}, null, function(respond) {
                    if (respond.status === 'OK') {
                        item.notify = false;

                        for (let obj in self.notifications) {
                            if (self.notifications[obj].notificationID == item.notificationID) {
                                self.$delete(self.notifications, obj);
                            }
                        }
                    }
                });
            }
        },
        watch: {
            $route() {
                if (this.$route.matched[0].path === '/order/:orderId' || this.$route.matched[0].path === '/reorder/:orderId') {
                    this.ordersStateActive = true;
                } else {
                    this.ordersStateActive = false;
                }

                if (this.$route.matched[0].path === '/configurator/:id' || this.$route.matched[0].path === '/configurator' || this.$route.matched[0].path === '/itemsList/:setId/:groupId' || this.$route.matched[0].path === '/orderFromCatalog') {
                    this.orderingActive = true;
                } else {
                    this.orderingActive = false;
                }

                if (this.$route.matched[0].path === '/configurator/:id' || this.$route.matched[0].path === '/configurator' || this.$route.matched[0].path === '/itemsList/:setId/:groupId') {
                    opened = '55px';
                    closed = '-401px';
                    this.bottomMenu = true;
                } else {
                    opened = '0px';
                    closed = '-456px';
                    this.bottomMenu = false;
                }

                if (this.$route.matched[0].path === '/basket') {
                    this.basketActive = true;
                    this.waitActive = false;
                } else {
                    this.basketActive = false;
                }

                if (this.$route.matched[0].path !== '/waitList') {
                    this.waitActive = false;
                }

                if (!this.chatBotState) {
                    this.chatBotClose();
                } else {
                    this.chatBotOpen();
                }
            }
        }
    }
</script>

<style>
    @import "./../assets/css/bootstrap.css";
    @import "./../assets/css/line-awesome/css/line-awesome.css";
    @import "./../assets/css/style.css";

    .print{
        display: none;
    }
    @media print{
        #head, #sfr_ch2022, .cont, h1, h3, br, #loadShop, .not-print, .topHeader, .headerBackground, footer {
            display:none !important
        }
        @page {size: portrait}
        a[href]:after { content: " (" attr(href) ")";}
        a[href]:after { content: "";}
        .print{
            display:block!important
        }
        #kontur{
            width: 100%; padding: 0
        }
    }

    nav .rm {
        position: relative;
        padding-right: 50px !important;
        background-image: url('./../assets/img/rm.png');
        background-repeat: no-repeat;
        background-position: right;
        background-size: 53px
    }
    nav .rm:hover, nav .rm.router-link-active {
        background-image: url('./../assets/img/rm2.png') !important;
        background-repeat: no-repeat !important;
        background-position: right !important;
        background-size: 53px !important;
    }
    nav .rm img {
        width: 32px;
        position: absolute;
        right: 0;
        top: -2px;
    }

    .ordering span {
        border-radius: 50%;
        height: 24px;
        width: 24px;
        display: inline-block;
        font-weight: bold;
        margin-left: 2px;
        font-size: 12px;
        text-align: center;
        line-height: 2;
    }

    .ordering.active span, .ordering:hover span, .ordering.router-link-active span {
        background: #0585bd !important;
        color: #fff !important;
    }
    .ordering span {
        background: #fff;
        color: #0585bd;
    }

    .credit {
        width: 300px;
        background-color: #fff;
        padding: 10px;
        color: #212529;
        display: block;
    }
    .credit:hover {
        text-decoration: none;
    }
    .credit i {
        font-size: 50px;
        color: #e10811;
    }
    .credit .warning {
        text-align: center;
    }
    .credit .text {
        font-size: 13px;
    }

    .storage {
        /*margin-top: 18px;*/
        position: relative;
    }

    .basket, .storage {
        background: transparent;
        color: #fff;
        border: none;
        font-size: 14px;
        border-radius: 0px;
        position: relative;
    }
    .basket:hover, .basket:focus, .basket:active,
    .storage:hover, .storage:focus, .storage:active
    {
        background: transparent !important;
        box-shadow: none;
        border-color: transparent;
    }

    .basket img, .storage img {
        width: 40px;
        margin-right: 10px;
    }

    .basket span {
        background-color: #fff;
        border-radius: 50px;
        color: #000;
        font-size: 11px;
        width: 16px;
        display: inherit;
        text-align: center;
        font-weight: bold;
        position: absolute;
        bottom: 5px;
        right: 10px;
    }

    .notice {
        position: fixed;
        top: 15px;
        right: 15px;
        background: #212529c2;
        padding: 30px;
        border-radius: 10px;
        opacity: 0;
        transition: opacity 0.15s ease;
        display: none;
        z-index: 2000;
    }

    .notice p {
        color: #fff;
        font-size: 20px;
        margin: 0;
    }

    .notice.active {
        opacity: 1;
        display: block;
    }

    .basketLink {
        /*display: block;*/
    }

    .basket.active {
        background-color: transparent !important;
        border-color: white !important;
        border: 2px solid;
        border-radius: 20px;
    }

    .router-link-active.notActive:not(.router-link-exact-active) {
        background-color: transparent !important;
        color: #fff !important;
    }

    .topNav {
        display: -ms-flexbox!important;
        display: flex!important;
        -ms-flex-preferred-size: auto;
        flex-basis: auto;
    }

    .notifications span {
        background-color: #fff;
        border-radius: 50px;
        color: #000;
        font-size: 11px;
        width: 16px;
        display: inline-block;
        text-align: center;
        font-weight: bold;
    }

    .v-popover {
        display: inline-block;
    }

    .notificationsPopover .table tr td {
        padding: 1px;
    }

    .notificationsPopover .table tr:first-of-type td {
        border-top: none;
    }

    .notifyHowTo {
        position: absolute;
        right: 5px;
        top: 5px;
        padding: 3px 7px;
    }

    /* Chat-bot */

    @-moz-keyframes blink {0%{opacity:1;} 50%{opacity:0;} 100%{opacity:1;}} /* Firefox */
    @-webkit-keyframes blink {0%{opacity:1;} 50%{opacity:0;} 100%{opacity:1;}} /* Webkit */
    @-ms-keyframes blink {0%{opacity:1;} 50%{opacity:0;} 100%{opacity:1;}} /* IE */
    @keyframes blink {0%{opacity:1;} 50%{opacity:0;} 100%{opacity:1;}} /* Opera and prob css3 final iteration */
    #preloader {
        /*background: #fff;*/
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        z-index: 999999;
        opacity: 1;
        filter: alpha(opacity=100);
        -webkit-transition: opacity 500ms ease;
        transition: opacity 500ms ease;
    }

    #preloader .logo {
        display: block;
        width: 39px;
        height: 39px;
        background-repeat: no-repeat;
        background-image: url('https://sale.katris.ru/img/ais.png');
        background-size: contain;
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -20px 0 0 -20px;
        -moz-transition:all 1s ease-in-out;
        -webkit-transition:all 1s ease-in-out;
        -o-transition:all 1s ease-in-out;
        -ms-transition:all 1s ease-in-out;
        transition:all 1s ease-in-out;
        /* order: name, direction, duration, iteration-count, timing-function */

    }

    .katrisChatBot {
        font-family: "Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-weight: 300;
        width: 350px;
        height: 500px;
        color: #2b313f;
        font-size: 12px;
        overflow: hidden;
        position: fixed;
        /*top: 0;*/
        /*bottom: 0;*/
        /*left: 0;*/
        right: 50px;

        box-shadow: 0px 20px 11px 1px #212529b8;

        transition-property: bottom;
        transition-duration: 0.7s;

        z-index: 997;
    }

    /*.onTop {*/
        /*bottom: 55px;*/
    /*}*/
    /*.onBottom {*/
        /*bottom: 0px;*/
    /*}*/
    .onTop {
        bottom: -401px;
    }
    .onBottom {
        bottom: -456px;
    }

    .katrisChatBot .user-request,
    .katrisChatBot .server-response {
        display: inline-block;
        padding: 15px 25px;
        border-radius: 3px;
        border: 1px solid #eee;
        margin-bottom: 5px;
        font-size: 16px;
        clear: both;
    }
    .katrisChatBot .user-request.server-response-error,
    .katrisChatBot .server-response.server-response-error {
        background-color: #f76949;
    }
    .katrisChatBot .user-request {
        background-color: #efefef;
        float: left;
        margin-right: 15px;
        margin-top: 15px;
        margin-left: 15px;
    }
    .katrisChatBot .server-response {
        color: #ffffff;
        background-color: #a5d175;
        float: right;
        margin-top: 15px;
        margin-right: 15px;
        margin-left: 15px;
    }
    .katrisChatBot .katrisChatBot_result {
        overflow-y: auto;
        background: white;
        position: absolute;
        top: 64px;
        bottom: 55px;
        width: 100%;
    }
    .katrisChatBot .katrisChatBot_result-table {
        height: 100%;
        min-height: 100%;
        width: 100%;
    }
    .katrisChatBot .katrisChatBot_result-table td {
        vertical-align: bottom !important;
    }
    .katrisChatBot .katrisChatBot_header {
        border-radius: 11px 11px 0px 0px;
        min-height: 40px;
        height: 44px;
        overflow: hidden;
        /*position: fixed;*/
        top: 0;
        width: 100%;
        background-color: #2b303e;
        display: table;
        cursor: pointer;
        z-index: 10;
    }
    .katrisChatBot .katrisChatBot_header-wrapper {
        display: table-cell;
        vertical-align: middle;
    }
    .katrisChatBot .katrisChatBot_header-icon {
        position: absolute;
        top: 5px;
        left: 20px;
        width: 30px;
        height: 30px;
        border-radius: 100%;
        /*background-color: @response-color;*/
        /* overflow: hidden;*/
        vertical-align: middle;
        text-align: center;
    }
    .katrisChatBot .katrisChatBot_header-icon img {
        max-height: 100%;
        max-width: 100%;
        width: auto;
        height: auto;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        border: 0;
        margin: auto;
    }
    .katrisChatBot .katrisChatBot_header-agent-name {
        padding-left: 80px;
        font-size: 18px;
        color: #ffffff;
    }
    .katrisChatBot .katrisChatBot_header-description {
        color: #b7bbc4;
        padding-left: 80px;
        padding-top: 1px;
        font-size: 12px;
        display: block;
        /* Fallback for non-webkit */
        display: -webkit-box;
        max-height: 24px;
        /* Fallback for non-webkit */
        margin: 0 auto;
        line-height: 1;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .katrisChatBot .block_input {
        position: absolute;
        bottom: 0;
        height: 55px;
        border-top: 1px solid lightgray;
        background-color: white;
        width: 100%;
    }
    .katrisChatBot #katrisChatBotForm {
        display: block;
        margin-left: 15px;
        margin-right: 55px;
    }
    .katrisChatBot #query {
        width: 100%;
        border: 0;
        font-size: 16px;
        font-weight: 300;
        margin: 0;
        height: 55px;
    }
    .katrisChatBot #query:focus {
        outline: none;
        outline-offset: 0;
    }
    .katrisChatBot .katrisChatBot_powered_by {
        /*position: fixed;*/
        left: 0;
        right: 0;
        top: 40px;
        height: 20px;
        background-color: #F8F8F8;
        vertical-align: middle;
    }
    .katrisChatBot .katrisChatBot_powered_by span {
        color: #b7bbc4;
        text-transform: uppercase;
        float: right;
        vertical-align: middle;
        line-height: 10px;
        margin-top: 5px;
        margin-right: 10px;
        font-size: 10px;
        margin-left: -10px;
    }
    .katrisChatBot .katrisChatBot_powered_by img {
        margin-top: 7px;
        height: 16px;
        margin-right: 20px;
        float: right;
        vertical-align: middle;
        border: 0;
    }
    .clearfix {
        clear: both;
    }

    .rotate {
        -webkit-animation-name: cog;
        -webkit-animation-duration: 5s;
        -webkit-animation-iteration-count: infinite;
        -webkit-animation-timing-function: linear;
        -moz-animation-name: cog;
        -moz-animation-duration: 5s;
        -moz-animation-iteration-count: infinite;
        -moz-animation-timing-function: linear;
        -ms-animation-name: cog;
        -ms-animation-duration: 5s;
        -ms-animation-iteration-count: infinite;
        -ms-animation-timing-function: linear;

        animation-name: cog;
        animation-duration: 5s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
    }
    @-ms-keyframes cog {
        from { -ms-transform: rotate(0deg); }
        to { -ms-transform: rotate(360deg); }
    }
    @-moz-keyframes cog {
        from { -moz-transform: rotate(0deg); }
        to { -moz-transform: rotate(360deg); }
    }
    @-webkit-keyframes cog {
        from { -webkit-transform: rotate(0deg); }
        to { -webkit-transform: rotate(360deg); }
    }
    @keyframes cog {
        from {
            transform:rotate(0deg);
        }
        to {
            transform:rotate(360deg);
        }
    }

    .Cookie__button {
        background-color: #007bff !important;
    }
    .Cookie__button:hover {
        background-color: #0069d9 !important;
    }

    .translation {
        margin-left: 34px;
    }
</style>
<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"/>
